/**
 * 将yyyy-mm-dd hh:mi:ss字符串转换成Date
 */
function parseyyyymmddhhmiss2Date(yyyymmddhhmiss) {
	var y = yyyymmddhhmiss.substring(0, 4);
	var m = yyyymmddhhmiss.substring(5, 7);
	var d = yyyymmddhhmiss.substring(8, 12);
	var h = yyyymmddhhmiss.substring(11, 13);
  var i = yyyymmddhhmiss.substring(14, 16);
	var s = yyyymmddhhmiss.substring(17, 19);
	return new Date(parseInt(y), parseInt(m) - 1, parseInt(d), parseInt(h), parseInt(i), parseInt(s));
}
/**
 * 将Date转换成yyyy-mm-dd字符串
 */
function parseDate2yyyymmdd(date) {
	var m = date.getMonth() + 1;
	var d = date.getDate();
	return date.getFullYear() + "-" + (m < 10 ? ("0" + m) : m) + "-" + (d < 10 ? ("0" + d) : d);
}

/**
 * 传入日期xxxx-yy-mm得到上一日日期
 */
function getYestoday(date) {
	var temp = date + " " + "00:00:00";
	var d = parseyyyymmddhhmiss2Date(temp);
	var yesterday_milliseconds = d.getTime() - 1000 * 60 * 60 * 24;
	var yesterday = new Date();
	yesterday.setTime(yesterday_milliseconds);
	var strYear = yesterday.getFullYear();
	var strDay = yesterday.getDate();
	var strMonth = yesterday.getMonth() + 1;
	if(strMonth < 10) {
		strMonth = "0" + strMonth;
	}
	if(strDay < 10) {
		strDay = "0" + strDay
	}
	var datastr = strYear + "-" + strMonth + "-" + strDay;
	return datastr;
}
/**
 * 传入日期xxxx-yy-mm得到下一日日期
 */
 function getNextday(date) {
	var temp = date + " " + "00:00:00";
	var k = parseyyyymmddhhmiss2Date(temp);
	var y = k.getFullYear();
	var m = k.getMonth();
	var d = k.getDate() + 1;
	var nextDate = new Date(y, m, d);
	var nextTime = parseDate2yyyymmdd(nextDate);
	return nextTime;
}
/**
 * 传入日期xxxx-yy得到上一个月日期
 */
function getPreMonth(date) {
	var year = date.substring(0, 4); //获取当前日期的年份
	var month = date.substring(5, 7); //获取当前日期的月份
	var year2 = year;
	var month2 = parseInt(month) - 1;
	if(month2 == 0) {
		year2 = parseInt(year2) - 1;
		month2 = 12;
	}
	if(month2 < 10) {
		month2 = '0' + month2;
	}

	var preMonth = year2 + '-' + month2;
	return preMonth;
}
/**
 * 传入日期xxxx-yy得到下一个月日期
 */
function getNextMonth(date) {
	var year = date.substring(0, 4); //获取当前日期的年份
	var month = date.substring(5, 7); //获取当前日期的月份
	var year2 = year;
	var month2 = parseInt(month) + 1;
	if(month2 == 13) {
		year2 = parseInt(year2) + 1;
		month2 = 1;
	}
	if(month2 < 10) {
		month2 = '0' + month2;
	}
	var nextMonth = year2 + '-' + month2;
	return nextMonth;
}
/**
 * 传入日期xxxx得到上一年日期
 */
function getPreYear(year) {
	var lastYear = parseInt(year) - 1;
	return lastYear;
}
/**
 * 传入日期xxxx得到下一年日期
 */
function getNextYear(year) {
	var nextYear = parseInt(year) + 1;
	return nextYear;
}
//指定天数之前的日期 date是传入的参数 （天数）
function getBeforeDate(date) {
	let data = date;
	let d = new Date();
	let year = d.getFullYear();
	let mon = d.getMonth() + 1;
	let day = d.getDate();
	if (day <= data) {
	  if (mon > 1) {
		mon = mon - 1;
	  } else {
		year = year - 1;
		mon = 12;
	  }
	}
	d.setDate(d.getDate() - data);
	year = d.getFullYear();
	mon = d.getMonth() + 1;
	day = d.getDate();
	let s =
	  year +
	  "-" +
	  (mon < 10 ? "0" + mon : mon) +
	  "-" +
	  (day < 10 ? "0" + day : day);
	return s;
}
// 防抖节流函数
function debounce(func, wait, immediate) {
    let timeout; // 定义一个计时器变量，用于延迟执行函数
    return function (...args) { // 返回一个包装后的函数
        const context = this; // 保存函数执行上下文对象
        const later = function () { // 定义延迟执行的函数
            timeout = null; // 清空计时器变量
            if (!immediate) func.apply(context, args); // 若非立即执行，则调用待防抖函数
        };
        const callNow = immediate && !timeout; // 是否立即调用函数的条件
        clearTimeout(timeout); // 清空计时器
        timeout = setTimeout(later, wait); // 创建新的计时器，延迟执行函数
        if (callNow) func.apply(context, args); // 如果满足立即调用条件，则立即执行函数
    };
}

// 节流函数
function throttle(func, wait) {
    let timeout; // 定义一个计时器变量，用于限制函数调用频率
    return function (...args) { // 返回一个包装后的函数
        const context = this; // 保存函数执行上下文对象
        if (!timeout) { // 如果计时器不存在
            func.apply(context, args); // 执行函数
            timeout = setTimeout(() => {
                timeout = null; // 清空计时器变量
            }, wait); // 创建计时器，在指定时间后重置计时器变量
        }
    };
}
export default {
  getYestoday: getYestoday,
  getNextday: getNextday,
  getPreMonth: getPreMonth,
  getNextMonth: getNextMonth,
  getPreYear: getPreYear,
  getNextYear: getNextYear,
  getBeforeDate: getBeforeDate,
  _debounce: debounce,
  _throttle: throttle,
}